<template>
    <header class="header">
        <div class="header__logo hidden-sm-down">
            <h1>
                <img :src="logo" alt="">
                <router-link :to="{ name: 'Home' }">
                    <a>
                        {{ $t('LBL_CONSENTS_MANAGER') }} - {{ companyName }}
                    </a>
                </router-link>
            </h1>
        </div>
        <ul class="top-nav">
            <li>
                <span>{{ fullName }}</span>
                <a @click="disconnect">
                    <i class="zmdi zmdi-power"></i>
                </a>
            </li>
        </ul>
    </header>
</template>

<script>
    export default {
        computed: {
            companyName() {
                return this.$store.state.companyInfo.name
            },

            fullName(){
                return this.$store.state.userInfo.firstname + ' ' + this.$store.state.userInfo.lastname
            },

            logo(){
                return process.env.BASE_URL + this.$store.state.companyInfo.logo
            }
        },

        methods: {
            async disconnect() {
                await Api.logout()
                this.$router.push({name: 'Login'})
            }
        }
    }
</script>

<style scoped lang="scss">
    .header__logo {
        img {
            width: 4rem;
            border-radius: 50%;
            margin-right: 0.2rem;
        }
    }

    .top-nav {
        a {
            display: inline-block;
            vertical-align: middle;
        }
        span {
            display: inline-block;
        }
    }

</style>


// WEBPACK FOOTER //
// src/layout/Header.vue